/**
 * Telegram WebApp wrapper — safe to call even when running outside Telegram
 * (in browser dev mode the methods become no-ops)
 */

export function tg(): TelegramWebApp | null {
  return window.Telegram?.WebApp ?? null
}

export function isInTelegram(): boolean {
  return Boolean(window.Telegram?.WebApp?.initData)
}

export function initTelegram() {
  const w = tg()
  if (!w) return
  w.ready()
  w.expand()
  // Lock dark theme in v1
  w.setHeaderColor('#070912')
  w.setBackgroundColor('#070912')

  // Safe-area CSS vars · cover ทั้ง iOS notch (safeAreaInset) + Telegram header (contentSafeAreaInset)
  // Telegram SDK v7+ มี API นี้ · เก่ากว่านั้น fallback เป็น 0 (env() ใน CSS จะใช้แทน)
  const w2 = w as unknown as {
    safeAreaInset?:        { top?: number; bottom?: number; left?: number; right?: number }
    contentSafeAreaInset?: { top?: number; bottom?: number; left?: number; right?: number }
    onEvent?: (e: string, cb: () => void) => void
  }
  const applySafeArea = () => {
    const sTop = (w2.safeAreaInset?.top ?? 0) + (w2.contentSafeAreaInset?.top ?? 0)
    const sBot = (w2.safeAreaInset?.bottom ?? 0) + (w2.contentSafeAreaInset?.bottom ?? 0)
    document.documentElement.style.setProperty('--tg-safe-top', `${sTop}px`)
    document.documentElement.style.setProperty('--tg-safe-bottom', `${sBot}px`)
  }
  applySafeArea()
  w2.onEvent?.('viewportChanged',        applySafeArea)
  w2.onEvent?.('safeAreaChanged',        applySafeArea)
  w2.onEvent?.('contentSafeAreaChanged', applySafeArea)
}

export function haptic(style: 'light' | 'medium' | 'heavy' = 'light') {
  tg()?.HapticFeedback?.impactOccurred(style)
}

export function notify(kind: 'success' | 'error' | 'warning' = 'success') {
  tg()?.HapticFeedback?.notificationOccurred(kind)
}

export function setBackButton(visible: boolean, onClick?: () => void) {
  const w = tg()
  if (!w) return
  if (visible) {
    if (onClick) w.BackButton.onClick(onClick)
    w.BackButton.show()
  } else {
    w.BackButton.hide()
  }
}

export function setMainButton(opts: { text: string; onClick: () => void } | null) {
  const w = tg()
  if (!w) return
  if (!opts) { w.MainButton.hide(); return }
  w.MainButton.setText(opts.text)
  w.MainButton.onClick(opts.onClick)
  w.MainButton.show()
}
